import * as React from 'react'
import { OnboardingComponentProps } from '.'
import { Stack, Spacing, Colors, Text } from '@doordash/design-language'
import styled from 'styled-components'
import { ErrorMessage } from '@doordash/component-fields'
import { get } from 'lodash'

export const SsnField = styled.div`
  width: 100%;
  iframe {
    width: 100%;
    height: 40px;
  }
`

export const SsnLabelWrapper = styled.div`
  margin-bottom: ${Spacing.XxxSmall}px;
  display: flex;
  justify-content: space-between;
`

export const VGSSsnFieldComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({
    data,
    label,
    description,
    error_message,
    ...props
  }: OnboardingComponentProps) => {
    const isValidField = get(props.value, `${data[0]}.isValid`, true)
    return (
      <React.Fragment>
        <Stack>
          <SsnLabelWrapper>
            <Text weight={Text.Weights.Bold} htmlFor={data[0]}>
              {label}
            </Text>
            <Text size={Text.Sizes.S14} color={Colors.SystemGrey80}>
              {description}
            </Text>
          </SsnLabelWrapper>
          <SsnField id={data[0]} />
          {!isValidField && <ErrorMessage error={error_message} />}
        </Stack>
      </React.Fragment>
    )
  }
)
